/**
 * Envia una petición AJAX con los datos especificados y ejecuta la funcionCompletado. Si falla prueba renovando el token.
 */
export async function sendAjaxRequest<ReturnType = unknown, paramType extends object = object>(type: "GET" | "POST", url: string, data?: paramType): Promise<ReturnType> {
	const opciones: RequestInit = {
		method: type,
		// dataType: "json",
		// cache: false,
		headers: {
			"Content-Type": "application/json;charset=utf-8",
			"Accept": "application/json",
			"Authorization": `Bearer ${getToken()}`,
		},
		body: type == "GET" ? undefined : JSON.stringify(data),
	};

	let queryParams = "";
	if (type == "GET" && data) {
		const params = new URLSearchParams();
		for (const key in data) {
			if (typeof data[key] === "string" || typeof data[key] === "number" || typeof data[key] === "boolean") {
				params.append(key, String(data[key]));
			} else if (Array.isArray(data[key])) {
				data[key].forEach(
					value => { params.append(`${key}[]`, String(value)); }
				);
			}
		}
		queryParams = `?${params.toString()}`;
	}

	const fullUrl = getApiURL(url, queryParams);
	const promiseReq = fetch(fullUrl, opciones);

	const res = await promiseReq;
	const body = await res.json() as ReturnType;
	if (!res.ok) {
		throw new HttpError(res.status, "Error en la petición", body);
	}

	return body;
}


function getToken() {
	const tokenStr = localStorage.getItem("token_mrp") ?? "";
	try {
		const token = JSON.parse(tokenStr) as unknown;
		if (typeof token === "string") return token;
		return token as string;
	} catch {
		return tokenStr;
	}
}

export class HttpError extends Error {
	public status: number;
	public body: unknown;

	public constructor(status: number, message: string, body: unknown) {
		super(message);
		this.status = status;
		this.body = body;
	}
}

export function getApiURL(url: string, queryParams = ""): string {
	const sessionUrl = sessionStorage.getItem("BASE_API_URL");
	const localUrl = sessionUrl ?? localStorage.getItem("BASE_API_URL");
	if (localUrl != null) return `${localUrl}${url}${queryParams}`;

	if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
		alert("Usando API local para desarrollo");
		return `http://api.almacen.piher.intranet${url}${queryParams}`;
	}

	let { hostname } = location;
	if (hostname.startsWith("www.")) hostname = hostname.substring(4);
	if (hostname.startsWith("web.")) hostname = hostname.substring(4);

	// Piher.com no tiene api.*, así que usa un subpath en /api/v1. Como la API ya tiene ese prefijo, termina como https://almacen.piher.com/api/v1/api/v1/anadirOF
	if (hostname == "almacen.piher.com") return `https://almacen.piher.com/api/v1${url}${queryParams}`;

	return `${location.protocol}//api.${hostname}${url}${queryParams}`;
}

//@ts-expect-error: Dev-only global function
window.setURL = (baseURL: string | null, sessionOnly: boolean): string => {
	if (baseURL == null) {
		if (sessionOnly) {
			sessionStorage.removeItem("BASE_API_URL");
			return "Session base URL cleared.";
		} else {
			sessionStorage.removeItem("BASE_API_URL");
			localStorage.removeItem("BASE_API_URL");
			return "Permanent and session base URL cleared.";
		}
	}

	if (sessionOnly) {
		sessionStorage.setItem("BASE_API_URL", baseURL);
		return `Session base URL set to ${baseURL}. Example query: ${getApiURL("/api/v1/anadirOF")}`;
	} else {
		localStorage.setItem("BASE_API_URL", baseURL);
		return `Permanent base URL set to ${baseURL}. Example query: ${getApiURL("/api/v1/anadirOF")}`;
	}

};